import { Component, OnInit, AfterViewInit } from "@angular/core";
import { AuthService } from "../../auth.service";
import { AppCommonService } from "../../appcommon.service";
import { ILoggedUser } from "../loggeduser/loggeduser";
import { HeaderAndNavigationService } from "../headerandnavigation.service";
import { Router } from "@angular/router";
declare var $: any;

@Component({
  selector: '[mft-sidenavigation]',
  templateUrl: './sidenavigation.component.html'
})
export class SideNavigation implements OnInit, AfterViewInit {
  loggedUser: ILoggedUser;
  innerWidth: any;

  public teleganceUrl = "https://www.fuelcardservices.com/tele-gence/";
  public myServiceExperturl = "https://www.fuelcardservices.com/my-service-expert/";
  public myDriveSafeExperturl = "https://www.fuelcardservices.com/my-drive-safe/";
  public milageCounturl = "https://www.fuelcardservices.com/mileagecount/"
  public showFuelCardAccount = true;

  constructor(private authService: AuthService,
    public headerAndNavigationService: HeaderAndNavigationService,
    private appCommonService: AppCommonService,
    public router: Router
  ) {
    this.router.events.subscribe(event => {
      if (event.constructor.name === "NavigationEnd") {
        // alert("A");
        //$('.page-sidebar.menu-compact .sidebar-menu li a span.menu-text').hide();
        // $('span.menu-text').show(0).delay(2000).fadeOut(800);
      }
    });
  }
  ngAfterViewInit(): void {
    this.appCommonService.loadRequiredJS();
  }
  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.loggedUser = this.headerAndNavigationService.getLoggedUser();
    if (this.loggedUser != null && this.loggedUser != undefined) {
      if (this.loggedUser.id == null || this.loggedUser.id == undefined) {
        this.showFuelCardAccount = false;
      }
    }
    //if (this.loggedUser != null && this.loggedUser.applications_access != null && this.loggedUser.applications_access != undefined) {
    //let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
    //if (userData == undefined) {
    //  userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
    //}
    //if (this.loggedUser != null && userData != null && userData != undefined) {

    //  console.log(userData);
    //  var applications_accessArray = JSON.parse(userData.applications_access);
    //  applications_accessArray.forEach(x => {
    //    if (x == 1) {
    //      this.milageCounturl = "https://mca.mileagecount.co.uk";
    //    }
    //    if (x == 2) {
    //      this.teleganceUrl = "https://app.tele-gence.com/";
    //    }
    //    if (x == 3) {
    //      this.myDriveSafeExperturl = "https://mds.myfleethub.co.uk";
    //    }
    //    if (x == 4) {
    //      this.myServiceExperturl = "https://mse.myfleethub.co.uk";
    //    }

    //  });
    //  //var applications_accessArray = JSON.parse("[" + this.loggedUser.applications_access + "]");
    //  //  applications_accessArray.forEach(x => {
    //  //      x.forEach(y => {
    //  //          x.forEach(y => {
    //  //              if (y == 1) {
    //  //                  this.milageCounturl = "https://mca.mileagecount.co.uk";
    //  //              }
    //  //              if (y == 2) {
    //  //                  this.teleganceUrl = "https://app.tele-gence.com/";
    //  //              }
    //  //              if (y == 3) {
    //  //                  this.myDriveSafeExperturl = "https://mds.myfleethub.co.uk";
    //  //              }
    //  //              if (y == 4) {
    //  //                  this.myServiceExperturl = "https://mse.myfleethub.co.uk";
    //  //              }
    //  //          })
    //  //      })

    //  //this.loggedUser.applications_access.forEach(x => {
    //  //  if (x == "1") {
    //  //    this.milageCounturl = "https://mca.mileagecount.co.uk/Account/Login.aspx";

    //  //  }
    //  //  if (x == "2") {
    //  //    this.teleganceUrl = "https://login.tele-gence.com/";

    //  //  }
    //  //  if (x == "3") {
    //  //    this.myDriveSafeExperturl = "/login"

    //  //  }
    //  //  if (x == "4") {
    //  //    this.myServiceExperturl = "http://login.myservice.expert/-box"

    //  //  }

    //  //});

    //}
    //debugger;
    if (this.loggedUser == null) {
      this.headerAndNavigationService.RedirectToLogin();
    }

    //debugger
    let impId = localStorage.getItem(this.authService.mftImpersonationId)
    if (impId != undefined && impId != null) {
      let userData = JSON.parse(sessionStorage.getItem(("userDataImpersonate_EServicesExternalLocalhost")));
      if (userData == undefined) {
        userData = JSON.parse(sessionStorage.getItem(("userDataImpersonate_EServicesExternal")));
      }
      if (this.loggedUser != null) {
        if (userData == undefined && userData == null) {
          this.headerAndNavigationService.callImperaonateAuthenticateToken(this.authService.getUserToken(), impId)
            .subscribe(
              (token: any) => {
                this.headerAndNavigationService.updateUserInfoXRM(token._body)
                  .subscribe(
                    (data: any) => {
                      //debugger
                      var userData = JSON.parse(data._body);
                      sessionStorage.setItem("userDataImpersonate_" + this.authService.clientId, data._body);
                      var applications_accessArray = JSON.parse(userData.applications_access);
                      applications_accessArray.forEach(x => {
                        if (x == 1) {
                          this.milageCounturl = "https://mca.mileagecount.co.uk";
                        }
                        if (x == 2) {
                          this.teleganceUrl = "https://app.tele-gence.com/";
                        }
                        if (x == 3) {
                          this.myDriveSafeExperturl = "https://mds.myfleethub.co.uk";
                        }
                        if (x == 4) {
                          this.myServiceExperturl = "https://mse.myfleethub.co.uk";
                        }


                      });
                    },
                    (error: any) => {

                    }
                  );
              },
              (error: any) => {

              }
            );
        }
        else {
          var applications_accessArray = JSON.parse(userData.applications_access);
          applications_accessArray.forEach(x => {
            if (x == 1) {
              this.milageCounturl = "https://mca.mileagecount.co.uk";
            }
            if (x == 2) {
              this.teleganceUrl = "https://app.tele-gence.com/";
            }
            if (x == 3) {
              this.myDriveSafeExperturl = "https://mds.myfleethub.co.uk";
            }
            if (x == 4) {
              this.myServiceExperturl = "https://mse.myfleethub.co.uk";
            }
          });
        }

      }
    }
    else {
      if (this.loggedUser != null && this.loggedUser.applications_access != null && this.loggedUser.applications_access != undefined) {
        var applications_accessArray = JSON.parse("[" + this.loggedUser.applications_access + "]");
        applications_accessArray.forEach(x => {
          x.forEach(y => {
            x.forEach(y => {
              if (y == 1) {
                this.milageCounturl = "https://mca.mileagecount.co.uk";
              }
              if (y == 2) {
                this.teleganceUrl = "https://app.tele-gence.com/";
              }
              if (y == 3) {
                this.myDriveSafeExperturl = "https://mds.myfleethub.co.uk";
              }
              if (y == 4) {
                this.myServiceExperturl = "https://mse.myfleethub.co.uk";
              }
            })
          })
        });
      }
    }











    //this.headerAndNavigationService.getLoggedUser()
    //  .subscribe(
    //  (user: ILoggedUser) => {
    //      this.loggedUser = user;
    //  },
    //  (error: any) => {
    //      this.headerAndNavigationService.showError("Logged user retrieval problem", <any>error);
    //      this.headerAndNavigationService.RedirectToLogin();
    //  }
    //);
  }


  MobileMenuLink(event: any) {
    var target = event.currentTarget;
    var pElementClass = target.parentElement.parentElement.parentElement.attributes.class.nodeValue;
    //console.log(pElementClass);

    if (innerWidth <= 1024) {
      if (pElementClass.indexOf("menu-compact") != -1) {
        var target = event.currentTarget;
        var pElement = target;
        var className = pElement.children[1];
        $(className).show(0).delay(1200).fadeOut(800);
      }
    }


  }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/sidenavigation/sidenavigation.component.ts